
import { findAll, find } from "../utils/dom";

const VIEWPORT_PADDING = 16;

function resetSubMenuPosition(subMenu) {
	subMenu.style.left = "";
	subMenu.style.right = "";
	subMenu.style.transform = "";
}

function computeShiftX(rect) {
	let shiftX = 0;

	if (rect.right > window.innerWidth - VIEWPORT_PADDING) {
		shiftX -= rect.right - (window.innerWidth - VIEWPORT_PADDING);
	}

	const shiftedLeft = rect.left + shiftX;
	if (shiftedLeft < VIEWPORT_PADDING) {
		shiftX += VIEWPORT_PADDING - shiftedLeft;
	}

	return shiftX;
}

function measureSubMenuMaxWidth(subMenu) {
	const panel = subMenu.querySelector('[js-content-sub-menu-grau2]');
	const lists = subMenu.querySelectorAll('[js-grau2-items]');

	if (!lists.length) {
		return subMenu.getBoundingClientRect();
	}

	const panelWasInvisible = panel?.classList.contains('invisible');
	panel?.classList.remove('invisible');
	lists.forEach((list) => list.classList.add('is-open'));

	const rect = subMenu.getBoundingClientRect();

	lists.forEach((list) => list.classList.remove('is-open'));
	if (panelWasInvisible) panel?.classList.add('invisible');

	return rect;
}

function adjustSubMenuPosition(subMenu) {
	resetSubMenuPosition(subMenu);

	const shiftX = computeShiftX(measureSubMenuMaxWidth(subMenu));

	if (shiftX !== 0) {
		subMenu.style.transform = `translateX(${shiftX}px)`;
	}
}

function hideAllGrau3Lists(subMenu) {
	subMenu?.querySelectorAll('[js-grau2-items]').forEach((list) => {
		list.classList.remove('is-open');
	});
}

function clearGrau2Active(subMenu) {
	subMenu?.querySelectorAll('.menu-grau2-item.is-active').forEach((item) => {
		item.classList.remove('is-active');
	});
}

function clearLevel1Active() {
	findAll('nav .menu-level1-link.is-active').forEach((link) => {
		link.classList.remove('is-active');
	});
}

function hideAllGrau3Panels() {
	findAll('[js-content-sub-menu-grau2]').forEach((panel) => {
		panel.classList.add('invisible');
	});
}

const Menu = () =>{

	const $ = {
		menuMobile: find('[js-menu-mobile]'),
		btOpenMobile: find(`[js-menu="open"]`),
		btClosedMobile: find(`[js-menu="closed"]`),

		menuDesktop: findAll(`nav [js-menu-desktop]`),
		menuDesktopGrau2: findAll(`nav [js-menu-grau2-desktop]`),
	}


	$.btOpenMobile?.addEventListener("click", (e)=>{
		$.menuMobile?.classList.add("active");
		$.btOpenMobile?.classList.remove("active");
		$.btClosedMobile?.classList.add("active");
	})

	$.btClosedMobile?.addEventListener("click", (e)=>{
		$.menuMobile?.classList.remove("active")
		$.btClosedMobile?.classList.remove("active");
		$.btOpenMobile?.classList.add("active");
	})



	function desativeAllMenu(){
		const subMenus = findAll(`[js-sub-menu-desktop].active`);
		subMenus?.forEach((item)=>{
			item.classList.remove("active");
			item.classList.add("invisible");
			resetSubMenuPosition(item);
			hideAllGrau3Lists(item);
			clearGrau2Active(item);
		})

		hideAllGrau3Panels();
		clearLevel1Active();
	}



	function removeAllActiveSubmenu(){
		const subMenus = findAll(`[js-sub-menu-desktop].active`);
		subMenus?.forEach((item)=>{
			item.classList.remove("active");
			item.classList.add("invisible");
			resetSubMenuPosition(item);
			hideAllGrau3Lists(item);
			clearGrau2Active(item);
		})

		hideAllGrau3Panels();
		clearLevel1Active();
	}
	
	$.menuDesktop?.forEach((item)=>{

		/** Evento hover */
		item?.addEventListener("mouseover", ()=>{
			const idMenu = item.getAttribute('js-menu-desktop');
			
			const subMenu = find(`[js-sub-menu-desktop='${idMenu}']`);
			if(subMenu){
				removeAllActiveSubmenu()
				subMenu.classList.add("active");
				subMenu.classList.remove('invisible');
				clearLevel1Active();
				item.classList.add('is-active');
				adjustSubMenuPosition(subMenu);

				if (!subMenu.dataset.menuLeaveBound) {
					subMenu.dataset.menuLeaveBound = '1';
					subMenu.addEventListener('mouseleave', () => {
						desativeAllMenu();
					});
				}
			}
		})
	})

	$.menuDesktopGrau2?.forEach((item)=>{
		item?.addEventListener("mouseenter", ()=>{
			const idMenu = item.getAttribute('js-menu-grau2-desktop');
			const subMenu = item.closest('[js-sub-menu-desktop]');
			const panel = subMenu?.querySelector('[js-content-sub-menu-grau2]');
			const itemsList = subMenu?.querySelector(`[js-grau2-items="${idMenu}"]`);
			const grau2Item = item.closest('.menu-grau2-item');

			hideAllGrau3Lists(subMenu);
			clearGrau2Active(subMenu);

			if (itemsList) {
				panel?.classList.remove('invisible');
				itemsList.classList.add('is-open');
				grau2Item?.classList.add('is-active');
			} else {
				panel?.classList.add('invisible');
			}
		});
	})
	

	
}

export default Menu;
